export const newsArticles = [
  {
    id: 1,
    slug: 'hilton-garden-inn-batam-groundbreaking',
    category: 'Proyek',
    title: 'WMM Mulai Konstruksi Hotel Hilton Garden Inn Batam Senilai Rp 137 Miliar',
    excerpt: 'PT Waringin Mega Mandiri resmi memulai pekerjaan struktur, arsitektur, dan plumbing Hotel Hilton Garden Inn Batam — proyek hotel bintang empat internasional 10 lantai dengan 2 basement seluas 19.860 m².',
    image: 'https://readdy.ai/api/search-image?query=luxury%20international%20hotel%20construction%20site%20Batam%20night%20view%2C%20tower%20crane%20warm%20amber%20work%20lights%2C%20dark%20dramatic%20sky%2C%20concrete%20formwork%20structure%2C%20cinematic%20moody%20construction%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=500&seq=wmm-news1-batam&orientation=landscape',
    author: 'Tim Redaksi WMM',
    date: '10 Januari 2026',
    readTime: '4 menit',
    featured: true,
    tags: ['Proyek', 'Hotel', 'Batam'],
  },
  {
    id: 2,
    slug: 'rumah-sakit-charitas-kenten-palembang',
    category: 'Proyek',
    title: 'WMM Tangani Pembangunan RS Charitas Kenten Palembang 5 Lantai Senilai Rp 76,6 Miliar',
    excerpt: 'Kepercayaan Yayasan Rumah Sakit Charitas kembali diberikan kepada WMM untuk membangun fasilitas kesehatan modern 5 lantai seluas 7.170 m² di Palembang — melanjutkan rekam jejak panjang WMM di Sumatera Selatan.',
    image: 'https://readdy.ai/api/search-image?query=modern%20hospital%20building%20construction%205%20floors%20Palembang%20night%20view%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20medical%20facility%20architecture%20under%20construction%2C%20cinematic%20moody%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=500&seq=wmm-news2-rs&orientation=landscape',
    author: 'Tim Redaksi WMM',
    date: '3 Januari 2026',
    readTime: '5 menit',
    featured: true,
    tags: ['Proyek', 'Rumah Sakit', 'Palembang'],
  },
  {
    id: 3,
    slug: 'rukan-marina-bay-pik2-selesai',
    category: 'Proyek',
    title: 'Rampung! WMM Selesaikan Rukan Marina Bay Manhattan PIK 2 Senilai Rp 140 Miliar',
    excerpt: '40 unit rukan premium seluas 46.200 m² di kawasan PIK 2 Jakarta Utara berhasil diselesaikan WMM tepat waktu — menjadi salah satu proyek komersial terbesar yang pernah ditangani perusahaan.',
    image: 'https://readdy.ai/api/search-image?query=luxury%20completed%20commercial%20shophouse%20complex%20PIK%202%20Jakarta%20waterfront%20night%20view%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20architecture%2C%20cinematic%20moody%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=500&seq=wmm-news3-pik2&orientation=landscape',
    author: 'Tim Redaksi WMM',
    date: '20 Desember 2025',
    readTime: '4 menit',
    featured: false,
    tags: ['Proyek', 'Ruko', 'Jakarta'],
  },
  {
    id: 4,
    slug: 'klenteng-jin-de-yuan-pik2',
    category: 'Proyek',
    title: 'WMM Garap Klenteng Jin De Yuan di Ecopark PIK 2 dengan Arsitektur Tionghoa Autentik',
    excerpt: 'Proyek unik dan bersejarah — WMM dipercaya membangun Klenteng Jin De Yuan di kawasan Ecopark PIK 2, menggabungkan keahlian struktur modern dengan detail arsitektur Tionghoa yang autentik.',
    image: 'https://readdy.ai/api/search-image?query=traditional%20Chinese%20temple%20klenteng%20construction%20PIK%202%20Jakarta%20night%20view%2C%20warm%20amber%20lighting%2C%20dark%20dramatic%20sky%2C%20ornate%20Chinese%20architecture%20under%20construction%2C%20cinematic%20moody%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=500&seq=wmm-news4-klenteng&orientation=landscape',
    author: 'Tim Redaksi WMM',
    date: '12 Desember 2025',
    readTime: '5 menit',
    featured: false,
    tags: ['Proyek', 'Rumah Ibadah', 'PIK 2'],
  },
  {
    id: 5,
    slug: 'rekam-jejak-16-tahun-konstruksi',
    category: 'Perusahaan',
    title: '16 Tahun WMM: Dari Hotel Amaris Pertama hingga Hilton Garden Inn — Perjalanan Kontraktor Nasional',
    excerpt: 'Sejak proyek pertama di 2010, WMM telah menyelesaikan lebih dari 75 proyek senilai Rp 3,5+ triliun di seluruh Indonesia. Inilah kisah pertumbuhan perusahaan yang konsisten menjaga kepercayaan klien.',
    image: 'https://readdy.ai/api/search-image?query=construction%20company%20milestone%20collage%20multiple%20buildings%20hotels%20apartments%20Indonesia%20night%20view%2C%20warm%20amber%20lighting%2C%20dark%20dramatic%20sky%2C%20cinematic%20moody%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=500&seq=wmm-news5-milestone&orientation=landscape',
    author: 'Divisi Komunikasi WMM',
    date: '5 Desember 2025',
    readTime: '7 menit',
    featured: false,
    tags: ['Perusahaan', 'Milestone', 'Sejarah'],
  },
  {
    id: 6,
    slug: 'sertifikasi-iso-sbu-lpjk',
    category: 'Perusahaan',
    title: 'WMM Pertahankan Sertifikasi ISO 9001:2015, SBU, dan LPJK — Standar Tertinggi Kontraktor Nasional',
    excerpt: 'Tiga sertifikasi bergengsi kembali dipertahankan WMM setelah melalui audit ketat. ISO 9001:2015 untuk mutu, SBU sebagai kualifikasi kontraktor tertinggi, dan LPJK sebagai bukti legalitas profesional.',
    image: 'https://readdy.ai/api/search-image?query=corporate%20certification%20award%20ceremony%20construction%20company%20Indonesia%2C%20dark%20sophisticated%20boardroom%20night%2C%20warm%20amber%20accent%20lighting%2C%20executives%20formal%20attire%2C%20dramatic%20shadows%2C%20cinematic%20photography%2C%20ultra%20realistic&width=800&height=500&seq=wmm-news6-sertifikasi&orientation=landscape',
    author: 'Divisi Quality Management WMM',
    date: '28 November 2025',
    readTime: '3 menit',
    featured: false,
    tags: ['Sertifikasi', 'ISO', 'LPJK'],
  },
  {
    id: 7,
    slug: 'apl-group-mitra-strategis',
    category: 'Perusahaan',
    title: 'Kemitraan Strategis WMM dengan APL Group: Lebih dari 15 Proyek Sukses Bersama',
    excerpt: 'Dari Podomoro Golf View Cimanggis, Kota Podomoro Tenjo, hingga Podomoro Park Bandung — WMM dan APL Group telah membangun kepercayaan melalui lebih dari 15 proyek residensial dan komersial berkualitas tinggi.',
    image: 'https://readdy.ai/api/search-image?query=strategic%20partnership%20construction%20developer%20meeting%20Indonesia%2C%20dark%20sophisticated%20office%20night%2C%20warm%20amber%20accent%20lighting%2C%20executives%20shaking%20hands%2C%20dramatic%20shadows%2C%20cinematic%20photography%2C%20ultra%20realistic&width=800&height=500&seq=wmm-news7-apl&orientation=landscape',
    author: 'Tim Redaksi WMM',
    date: '18 November 2025',
    readTime: '5 menit',
    featured: false,
    tags: ['Kemitraan', 'APL Group', 'Proyek'],
  },
  {
    id: 8,
    slug: 'springhill-terrace-241-miliar',
    category: 'Proyek',
    title: 'Flashback: Springhill Terrace Residence — Proyek Apartemen 27 Lantai Senilai Rp 241 Miliar',
    excerpt: 'Salah satu proyek terbesar dalam sejarah WMM: Springhill Terrace Residence Jakarta, apartemen 27 lantai + 1 basement seluas 72.000 m². Bagaimana WMM mengelola proyek skala masif ini?',
    image: 'https://readdy.ai/api/search-image?query=luxury%20high%20rise%20apartment%20tower%2027%20floors%20completed%20Jakarta%20night%20view%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20premium%20residential%20architecture%2C%20cinematic%20moody%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=500&seq=wmm-news8-springhill&orientation=landscape',
    author: 'Tim Redaksi WMM',
    date: '10 November 2025',
    readTime: '6 menit',
    featured: false,
    tags: ['Proyek', 'Apartemen', 'Jakarta'],
  },
  {
    id: 9,
    slug: 'konstruksi-hotel-bintang-indonesia',
    category: 'Insight',
    title: 'Spesialisasi Hotel: Mengapa WMM Menjadi Pilihan Utama Jaringan Hotel Internasional di Indonesia',
    excerpt: 'Dari Amaris, Aston, Marriott, Ibis, hingga Hilton — WMM telah membangun lebih dari 20 hotel berbintang di seluruh Indonesia. Apa rahasia di balik kepercayaan jaringan hotel internasional kepada WMM?',
    image: 'https://readdy.ai/api/search-image?query=multiple%20luxury%20hotel%20buildings%20Indonesia%20night%20view%20collage%2C%20warm%20amber%20facade%20lighting%2C%20dark%20dramatic%20sky%2C%20various%20hotel%20architecture%20styles%2C%20cinematic%20moody%20photography%2C%20deep%20shadows%2C%20ultra%20realistic&width=800&height=500&seq=wmm-news9-hotel&orientation=landscape',
    author: 'Divisi Teknik WMM',
    date: '1 November 2025',
    readTime: '8 menit',
    featured: false,
    tags: ['Insight', 'Hotel', 'Spesialisasi'],
  },
];

export const newsCategories = ['Semua', 'Proyek', 'Perusahaan', 'Kemitraan', 'Sertifikasi', 'Insight'];
